"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppMenuItem = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_2 = require("@headlessui/react");
const useHover_1 = __importDefault(require("../../hooks/useHover"));
const Image_1 = require("../Image");
function AppMenuItem(_a) {
    var { className, href, src, title, alt, text, linkProps } = _a, props = __rest(_a, ["className", "href", "src", "title", "alt", "text", "linkProps"]);
    const [ref, isHovered] = (0, useHover_1.default)();
    return (react_1.default.createElement(react_2.Menu.Item, Object.assign({ as: "li" }, props), ({ active }) => (react_1.default.createElement("div", { className: "relative" },
        react_1.default.createElement("a", Object.assign({ ref: ref, href: href, className: (0, classnames_1.default)('flex flex-col justify-center items-center relative', { underline: active }, className) }, linkProps),
            react_1.default.createElement(Image_1.Image, { src: src, title: title, alt: alt }),
            react_1.default.createElement("p", { className: "text-xs mt-1" }, text)),
        react_1.default.createElement("div", null, isHovered && (react_1.default.createElement(react_2.Transition, { enter: "transition duration-300 ease-out", enterFrom: "transition opacity-0", enterTo: "transition opacity-100", leave: "transition duration-300 ease-out", leaveFrom: "transition opacity-100", leaveTo: "transition opacity-0" },
            react_1.default.createElement("div", { className: "bg-black rounded p-2 absolute z-10 left-0 top-2 transform -translate-x-full -mx-1" },
                react_1.default.createElement("aside", { className: "absolute w-4 h-4 bg-black transform rotate-45 -right-0.5 -z-1" }),
                react_1.default.createElement("p", { className: "text-white text-xs whitespace-nowrap" }, title)))))))));
}
exports.AppMenuItem = AppMenuItem;
